import axios from "axios";
import { getToken, getEmail, getRole, notify } from "../utils/utils";

const baseUrl = "https://redact.octalooptechnologies.com/";
const authHeader = () => ({ headers: { "x-access-token": getToken() } });

export const signUpAPI = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/signup`, data);
    notify("Signup successful!", "success");
    return res.data;
  } catch (error) {
    notify(`Signup failed: Email already exists!`, "error");
    throw error.response.data;
  }
};

export const loginAPI = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/login`, data);
    notify("Login successful!", "success");
    return res.data;
  } catch (error) {
    notify(error.response.data.message, "error");
    throw error.response.data;
  }
};

export const forgotPasswordAPI = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/forgot_password`, data);
    notify("Verification code sent", "success");
    return res.data;
  } catch (error) {
    notify(error.response.data.error, "error");
    throw error.response.data;
  }
};

export const VerifyCodeApi = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/verify_recovery_code`, data);
    notify("Code verified!", "success");
    return res.data;
  } catch (error) {
    notify(`Invalid recovery code!`, "error");
    throw error.response.data;
  }
};

export const resetPasswordApi = async (data) => {
  try {
    const res = await axios.post(`${baseUrl}/reset_password`, {
      ...data,
      email: getEmail(),
      role: getRole(),
    });
    notify("Password reset successfully!", "success");
    return res.data;
  } catch (error) {
    console.log(error);
    notify(`Failed to reset password!`, "error");
    throw error.response.data;
  }
};

export const getProfileAPI = async () => {
  try {
    const data = {
      email: getEmail(),
      role: getRole(),
    };
    const res = await axios.post(`${baseUrl}/get_profile`, data, authHeader());
    return res.data.profile;
  } catch (error) {
    throw error.response.data;
  }
};

export const getProfileByAdminAPI = async (email) => {
  try {
    const data = {
      email: email,
      role: "user",
    };
    const res = await axios.post(`${baseUrl}/get_profile`, data, authHeader());
    return res.data.profile;
  } catch (error) {
    throw error.response.data;
  }
};

export const editProfileAPI = async (data) => {
  try {
    data = { ...data, role: getRole() };
    const res = await axios.post(`${baseUrl}/edit_profile`, data, authHeader());
    notify("Profile updated successfully!", "success");
    return res;
  } catch (error) {
    notify(`Unable to update profile!`, "error");
    throw error.response.data;
  }
};

export const editProfileByAdminAPI = async (data) => {
  try {
    data = { ...data, role: "user" };
    const res = await axios.post(
      `${baseUrl}/admin/edit_user`,
      data,
      authHeader()
    );
    notify("User profile updated successfully!", "success");
    return res;
  } catch (error) {
    notify(`Unable to update user profile!`, "error");
    throw error.response.data;
  }
};

export const changePasswordApi = async (data) => {
  try {
    data = {
      ...data,
      role: getRole(),
      email: getEmail(),
    };
    const res = await axios.post(
      `${baseUrl}/change_password`,
      data,
      authHeader()
    );
    notify("Password updated successfully!", "success");
    return res.data;
  } catch (error) {
    notify(error.response.data.message, "error");
    throw error;
  }
};

export const GetPendingUsersAPI = async () => {
  try {
    const res = await axios.get(`${baseUrl}/pending_users`, authHeader());
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const GetApprovedUsersAPI = async () => {
  try {
    const res = await axios.get(`${baseUrl}/approved_users_list`, authHeader());
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const ApproveUserAPI = async (user) => {
  try {
    const res = await axios.post(`${baseUrl}/approve_user`, user, authHeader());
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const uploadFilesAPI = async ({ files, email }) => {
  try {
    const formData = new FormData();
    formData.append("email", email);

    files.forEach((file) => {
      formData.append("files", file.file);
      formData.append("ids", file.id); 
    });

    const response = await axios.post(
      `${baseUrl}/upload`,
      formData,
      authHeader()
    );

    notify("Files uploaded successfully!", "success");

    // Ensure the response includes IDs
    return response.data.map((file, index) => ({
      ...file,
      doc_id: files[index].id,
    }));
  } catch (error) {
    notify("File not Supported", "error");
    throw error;
  }
};

export const getUserDocs = async () => {
  try {
    const email = getEmail();
    const response = await axios.post(
      `${baseUrl}/user_documents`,
      { email: email },
      {
        headers: {
          "x-access-token": getToken(),
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
